/*Country Flag*/


$(document).ready(function() {
    // Check the cart contents on page load
    $.getJSON('/cart.js', function(cart) {
      var hasCustomOrder = false;
      
      // Check if any item in the cart is named "Custom Order"
      $.each(cart.items, function(index, item) {
        if (item.title === "Custom Order") {
          hasCustomOrder = true;
          return false; // Exit loop once found
        }
      });

      console.log(hasCustomOrder);

      // if (hasCustomOrder) {
      //   $.ajax({
      //     type: 'POST',
      //     url: '/cart/update.js',
      //     data: JSON.stringify({
      //       updates: {},
      //       note: "SHIP_DISC"
      //     }),
      //     contentType: 'application/json',
      //     success: function() {
      //       // Optional: Reload the cart page to reflect the discount
      //       location.reload();
      //     },
      //     error: function() {
      //       console.error('Error applying the discount code.');
      //     }
      //   });
      // }
      });
  });
$(document).click(function () {
      $('.select-country-content').css('display', 'none');
  });

$(document).on('click', '.select-country-button', function (event) {
    event.stopPropagation();
    if (!$(this).parent().parent().hasClass('desktop-only')) {
        if ($('.select-country-content').css('display') == 'none') {
            $('.select-country-content').css('display', 'block');
            $('.selector_toggle-arrow svg').addClass('up');
        } else {
            $('.select-country-content').css('display', 'none');
            $('.selector_toggle-arrow svg').removeClass('up');
        }
    } else {
        if ($('.select-country-content').css('display') == 'none') {
            $('.select-country-content').css('display', 'block');
        } else {
            $('.select-country-content').css('display', 'none');
        }
    }
});

function checkCookie() {
    var path = getCookie("user_selected_country");
    if (path != "") {
        return true;
    } else {
        return false;
    }
}
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

var is_check_cookie = checkCookie();
if (!is_check_cookie) {
    $('.loading-holder').hide(); 
    $.get("https://xococo.surf/browsing_context_suggestions.json", function (response) {
        var selectedCountries = ["AU", "NZ"];
        var ipCountry = response.detected_values.country.handle;
        if (selectedCountries.includes(ipCountry)) {
            if (!window.Shopify.designMode) {
                $('.redirect-modal').show();
                setCookie('user_selected_country', '1', 1);
                setTimeout(function () {
                    window.location.href = 'https://xococosurf.au/';
                }, 4000);
            }
        }
        else {
            $('.loading-holder').hide();
        }
    }, "jsonp"); 
}
else {
    $('.loading-holder').hide();
}